import { Routes } from '@angular/router';
import { RegistrationAdmissionsClosedComponent } from './registration-admissions-closed/registration-admissions-closed.component';
import { RegistrationError404Component } from './registration-error404/registration-error404.component';
import { RegistrationWelcomeComponent } from './registration-welcome/registration-welcome.component';

export const APP_ROUTES: Routes = [
  { path: 'not-found', component: RegistrationError404Component },
  {
    path: ':schoolCode/admissions-closed',
    component: RegistrationAdmissionsClosedComponent,
  },
  {
    path: ':schoolCode/admission',
    loadChildren: () =>
      import('./registration/registration.routes').then(
        (m) => m.REGISTRATION_ROUTES,
      ),
  },
  { path: ':schoolCode', component: RegistrationWelcomeComponent },
  { path: '**', redirectTo: '/not-found' },
];
